module.exports = __webpack_public_path__ + "assets/img/right.9c122350.png";